/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Game_Your_GuessInputs */

const bn_game_your_guess = /** @type {(inputs: Game_Your_GuessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার অনুমান`)
};

const de_game_your_guess = /** @type {(inputs: Game_Your_GuessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Deine Vermutung`)
};

const el_game_your_guess = /** @type {(inputs: Game_Your_GuessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η εικασία σας`)
};

const en_game_your_guess = /** @type {(inputs: Game_Your_GuessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your guess`)
};

const es_game_your_guess = /** @type {(inputs: Game_Your_GuessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`tu suposición`)
};

const fr_game_your_guess = /** @type {(inputs: Game_Your_GuessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Votre réponse`)
};

const hi_game_your_guess = /** @type {(inputs: Game_Your_GuessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`तुम्हारा अनुमान`)
};

const hu_game_your_guess = /** @type {(inputs: Game_Your_GuessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A te sejtésed`)
};

const id_game_your_guess = /** @type {(inputs: Game_Your_GuessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tebakan Anda`)
};

const it_game_your_guess = /** @type {(inputs: Game_Your_GuessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La tua ipotesi`)
};

const ja_game_your_guess = /** @type {(inputs: Game_Your_GuessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`あなたの推測`)
};

const ko_game_your_guess = /** @type {(inputs: Game_Your_GuessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`당신의 추측`)
};

const nl_game_your_guess = /** @type {(inputs: Game_Your_GuessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Jouw gok`)
};

const pl_game_your_guess = /** @type {(inputs: Game_Your_GuessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Twoje przypuszczenie`)
};

const pt_game_your_guess = /** @type {(inputs: Game_Your_GuessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Seu palpite`)
};

const ru_game_your_guess = /** @type {(inputs: Game_Your_GuessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваше предположение`)
};

const sv_game_your_guess = /** @type {(inputs: Game_Your_GuessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Din gissning`)
};

const tr_game_your_guess = /** @type {(inputs: Game_Your_GuessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tahminin`)
};

const uk_game_your_guess = /** @type {(inputs: Game_Your_GuessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ваша здогадка`)
};

const vi_game_your_guess = /** @type {(inputs: Game_Your_GuessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`dự đoán của bạn`)
};

const zh_game_your_guess = /** @type {(inputs: Game_Your_GuessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的猜测`)
};

const zh_hant_game_your_guess = /** @type {(inputs: Game_Your_GuessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`你的猜測`)
};

/**
* | output |
* | --- |
* | "Your guess" |
*
* @param {Game_Your_GuessInputs} inputs
* @param {{ locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }} options
* @returns {LocalizedString}
*/
export const game_your_guess = /** @type {((inputs?: Game_Your_GuessInputs, options?: { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Game_Your_GuessInputs, { locale?: "bn" | "de" | "el" | "en" | "es" | "fr" | "hi" | "hu" | "id" | "it" | "ja" | "ko" | "nl" | "pl" | "pt" | "ru" | "sv" | "tr" | "uk" | "vi" | "zh" | "zh-hant" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "bn") return bn_game_your_guess(inputs)
	if (locale === "de") return de_game_your_guess(inputs)
	if (locale === "el") return el_game_your_guess(inputs)
	if (locale === "en") return en_game_your_guess(inputs)
	if (locale === "es") return es_game_your_guess(inputs)
	if (locale === "fr") return fr_game_your_guess(inputs)
	if (locale === "hi") return hi_game_your_guess(inputs)
	if (locale === "hu") return hu_game_your_guess(inputs)
	if (locale === "id") return id_game_your_guess(inputs)
	if (locale === "it") return it_game_your_guess(inputs)
	if (locale === "ja") return ja_game_your_guess(inputs)
	if (locale === "ko") return ko_game_your_guess(inputs)
	if (locale === "nl") return nl_game_your_guess(inputs)
	if (locale === "pl") return pl_game_your_guess(inputs)
	if (locale === "pt") return pt_game_your_guess(inputs)
	if (locale === "ru") return ru_game_your_guess(inputs)
	if (locale === "sv") return sv_game_your_guess(inputs)
	if (locale === "tr") return tr_game_your_guess(inputs)
	if (locale === "uk") return uk_game_your_guess(inputs)
	if (locale === "vi") return vi_game_your_guess(inputs)
	if (locale === "zh") return zh_game_your_guess(inputs)
	return zh_hant_game_your_guess(inputs)
});